import CadastroUsuarioModal from './CadastroUsuarioModal';

export default CadastroUsuarioModal;
